var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "download-specs-block" }, [
    _c("h5", { staticClass: "download-specs-header" }, [
      _vm._v(
        _vm._s(_vm.$resourceString["virtualtray.download.specs.modal.header"])
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "wf-modal-button-close btn button-full",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.hideModal("download-specs")
          }
        }
      },
      [
        _c("span", {
          staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
          attrs: { "aria-label": "Close modal" }
        })
      ]
    ),
    _vm._v(" "),
    _c("h6", { staticClass: "download-specs-subheader" }, [
      _vm._v(
        "\n\t\t\t" +
          _vm._s(
            _vm.$resourceString["virtualtray.download.specs.modal.subheader"]
          ) +
          "\n\t\t"
      )
    ]),
    _vm._v(" "),
    Object.keys(_vm.trayData).length === 0
      ? _c("p", { staticClass: "download-specs-no-items-fm" }, [
          _vm._v(_vm._s(_vm.$resourceString["virtualtray.no.items.1"]))
        ])
      : _vm._e(),
    _vm._v(" "),
    Object.keys(_vm.trayData).length === 0
      ? _c("p", { staticClass: "download-specs-no-items-sm" }, [
          _vm._v(_vm._s(_vm.$resourceString["virtualtray.no.items.2"]))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.getPdmsLinks.length > 0
      ? _c(
          "ul",
          { staticClass: "download-specs-list" },
          _vm._l(_vm.getPdmsLinks, function(item) {
            return _c(
              "li",
              {
                key: item.id,
                staticClass: "download-specs-list-element d-flex"
              },
              [
                _c("img", {
                  staticClass: "download-specs-image",
                  attrs: { src: item.backgroundTileImage }
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "download-specs-link spec-pdf-download",
                    attrs: { href: item.pdmsLink, target: "_blank" }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(
                          (item.sellingStyleNumber
                            ? item.sellingStyleNumber
                            : item.styleNumber) +
                            " " +
                            (item.sellingStyleName
                              ? item.sellingStyleName
                              : item.styleName)
                        ) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }